var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { useLockBodyScroll } from './hooks/useLockBodyScroll';
import { Backdrop } from './Backdrop';
import { Dialog } from './Dialog';
import { Portal } from './Portal';
import { DrawerElement } from './Drawer.style';
var Drawer = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'drawer-root' : _b, _c = _a.open, open = _c === void 0 ? false : _c, children = _a.children, onClose = _a.onClose, width = _a.width, rounded = _a.rounded, props = __rest(_a, ["id", "open", "children", "onClose", "width", "rounded"]);
    useLockBodyScroll(open);
    return (React.createElement(AnimatePresence, null, open && (React.createElement(Portal, { id: id },
        React.createElement(DrawerElement, null,
            React.createElement(Backdrop, __assign({}, props),
                React.createElement(Dialog, { width: width, onClose: onClose, rounded: rounded }, children)))))));
};
export { Drawer };
//# sourceMappingURL=Drawer.js.map